<script>
	import PrimaryButton from './PrimaryButton.svelte';
	let className = '';
	export { className as class };
	export let width;
	export let height;
	export let fontSize;
	export let text;
	export let disabled = true;
	export let onClick = () => {};
	export let onMouseDown = () => {};
</script>

<div class="wrapperPrimaryGray">
	<PrimaryButton
		class="gray-btn {className}"
		{width}
		{height}
		{fontSize}
		{disabled}
		{text}
		{onClick}
		{onMouseDown}
	/>
</div>

<style>
	.wrapperPrimaryGray {
		width: fit-content;
		height: fit-content;
	}
	.wrapperPrimaryGray :global(.gray-btn) {
		background: linear-gradient(45deg, #cbcbcb 50%, #a6a6a6 50%) !important;
		box-shadow: 0px -4px 0px #545454 inset !important;
	}
</style>
